import { mapGetters } from 'vuex';
import store from '../../../store';

import Modal from '../dialog/dialog.vue';
import Checkbox from '../checkbox/checkbox.vue';
import Sticky from '../sticky/sticky.vue';
import FilterInput from '../filter-input/filter-input.vue';
import Spinner from '../spinner/spinner.vue';
import MetadataInfo from '../metadata-info/metadata-info.vue';

import Logger from '../../../logger';

import OptionsMixin from './options.mixin';
import InfinityScrollMixin from '../../../mixins/infinity.scroll.mixin';

import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import debounce from 'lodash/debounce';
import keys from 'lodash/keys';
import slice from 'lodash/slice';
import reduce from 'lodash/reduce';

import l10n from '../../../transformers/l10n';

const INPUT_DEBOUNCE_TIME  = 250;  // ms
const PAGE_SIZE = 50; // items
const logger = new Logger('FacetMoreOptionsPopup');

export default {
   name: 'FacetMoreOptionsPopup',
   store,
   mixins: [ OptionsMixin, InfinityScrollMixin ],
   components: { Modal, Checkbox, FilterInput, Sticky, Spinner, MetadataInfo },
   data() {
      return {
         selectedAsMap: {},
         facetName: '',
         loading: false,
         useAutoFocused: false, //!canUseVirtualKeyboard(),
         limit: PAGE_SIZE,
         filter: '',
         limitedOptions: [],
         filteredOptions: [],
         modalOptions: {
            showHeader: false,
            confirmText: 'Select',
            cancelText: 'Cancel'
         }
      };
   },
   computed: {
      rejectedValue() {
         return false;
      },
      resolvedValue() {
         return keys(this.selectedAsMap);
      },
      hasNextPage() {
         return this.limit < this.filteredOptions.length;
      },
      selectedWrapper() {
         const { scroll } = this.$refs;
         return scroll.$refs.container;
      },
      placeholder() {
         return l10n('facets.search_placeholder');
      },
      ...mapGetters(['getFullListOfFacets'])
   },
   mounted() {
      this.selectedAsMap = reduce(this.$options.selected, (memo, id) => {
         memo[id] = true;
         return memo;
      }, {});
      this.loadFacets();
   },
   methods: {
      _onload() {
         this.options = sortBy(this.getFullListOfFacets, 'name');
         this.loading = false;
         this._defineFilteredOptionsByFilter();
      },
      _setFilteredOptions(options) {
         this.filteredOptions = options;
         this.limit = 0;
         this.loadNextPage();
      },
      loadFacets() {
         let _loader = this.$options.loader;
         if (_loader) {
            this.loading = true;
            const selected = keys(this.selectedAsMap);
            _loader(selected).then(this._onload).catch(this._onload);
         } else {
            logger.error('Did\'t find the loader for facet\'s options');
         }
      },
      onChangeMoreOption(option, val) {
         this.onChangeOption(option, val);
         this.loadFacets();
      },
      loadNextPage() {
         const zero = 0;
         this.limit += PAGE_SIZE;
         this.limitedOptions = slice(this.filteredOptions, zero, this.limit);
      },
      _defineFilteredOptionsByFilter: debounce(function _def() {
         // eslint-disable-next-line no-invalid-this
         var re = new RegExp(this.filter, 'i');
         // eslint-disable-next-line no-invalid-this
         this._setFilteredOptions(filter(this.options, o => re.test(o.name)));
         // eslint-disable-next-line no-invalid-this
         // this.$refs.scroll.scrollTop = 0;
      }, INPUT_DEBOUNCE_TIME)
   },
   watch: {
      filter() {
         this._defineFilteredOptionsByFilter();
      }
   }
};
